module.exports = __webpack_public_path__ + "img/bank.d377ff3d.svg";